export const snakeCase = (str: string): string =>
  str
    .split(/(?=[A-Z])/)
    .join("_")
    .toLowerCase();

export function randomString(length: number): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  let result = "";
  for (const v of randomValues) {
    result += characters.charAt(v % charactersLength);
  }
  return result;
}

/**
 * Finds email addresses inside free-form text (see `isEmail` for whole-string
 * validation).
 *
 * The whole pattern is wrapped in one capture group on purpose, so
 * `String.prototype.split(EMAIL_REGEX)` keeps the matched emails in its result
 * array (they land at the odd indices). It is intentionally non-global, so a
 * shared instance stays safe to reuse with `.test()` (no `lastIndex` state).
 */
export const EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;

// Anchored form of EMAIL_REGEX, for validating that an entire string is an email.
const EMAIL_EXACT_REGEX = new RegExp(`^${EMAIL_REGEX.source}$`);

/** Returns true when `value` is a well-formed email address (whole-string match). */
export const isEmail = (value: string): boolean => EMAIL_EXACT_REGEX.test(value);
